import React, {useRef} from "react";
import "./SectionHeading3.css";

const SectionHeading3 = ({title, description}) => {
  const sectionRef = useRef(null);

  return (
    <div
      className="section-heading3-grid section-heading3-container"
      ref={sectionRef}
    >
      <div className="section-heading3-content">
        <div className="section-wrapper" data-delay=".3">
          <h2 className="section-title" style={{perspective: "300px"}}>
            <span className="section-title-word">
              <span className="section-title-char">{title}</span>
            </span>
          </h2>

          <div className="section-description">
            <p>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionHeading3;
